import React from "react";
import {
    Button,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Typography,
} from "@mui/material";
import SearchSharpIcon from "@mui/material/SvgIcon/SvgIcon";
import { noop } from "lodash";

type LandingCardProps = {
    action?: () => void;
    img?: {
        alt: string;
        href: string;
    };
    text: React.ReactNode;
    actionText: React.ReactNode;
    title: React.ReactNode;
    "aria-disabled"?: boolean;
};

const LinkCard: React.FC<LandingCardProps> = ({
    action = noop,
    img,
    title,
    text,
    actionText,
    ...props
}: LandingCardProps) => {
    return (
        <Card>
            {" "}
            <CardActionArea
                onClick={() => action()}
                disabled={props["aria-disabled"]}
            >
                {img ? (
                    <CardMedia
                        component="img"
                        alt={img.alt}
                        height="140"
                        image={img.href}
                        title={img.alt}
                    />
                ) : null}
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        {title}
                    </Typography>
                    {text}
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button
                    size="small"
                    color="primary"
                    endIcon={<SearchSharpIcon />}
                    onClick={action}
                >
                    {actionText}
                </Button>
            </CardActions>
        </Card>
    );
};

export default LinkCard;
